module.exports = __webpack_public_path__ + "img/type13.68c253f9.png";